export default {
  'buttons': [
    {
      id: 0,
      method: '$openPopupAddPlace',
      title: 'components.billboard.add-object'
    }
  ]
}
